import classNames from 'classnames';
import { Button } from '../../components';
import IButtonLinkProps from './ButtonLinkProps';

const ButtonLink = ({ tag, href, children, className, exact, newTab, ...other }: IButtonLinkProps) => {
  const classes = classNames(
    {
      'btn-nav-link': true,
    },
    className
  );

  return (
    <Button
      tag={tag}
      className={classes}
      {...other}
      {...(tag === 'a'
        ? { href, target: newTab ? '_blank' : '_self' }
        : { exact, to: href, target: newTab ? '_blank' : '_self' })}
    >
      {children}
    </Button>
  );
};

ButtonLink.defaultProps = {
  ...Button.defaultProps,
  tag: 'a',
  exact: true,
  ripple: true,
  tabIndex: 0,
  newTab: false,
};

export default ButtonLink;
